import types from '../types'
import {
  getAuth,
} from 'firebase/auth'

export const signOut = () => (dispatch, getState) => {
  getAuth().signOut()
      .then(() => {
        dispatch({
          type: types.STORE_PAYLOAD,
          payload: {
            isSignedIn: false,
            isLoading: false,
          },
        })
      })
      .then(() => dispatch({type: 'CLEAR_STORE'}))
      .catch((error) => {
        // console.log('Error on sign out', error)
      })
}
